import { UserRole } from 'providence-types';

export const isNotOnlyReadOnlyUser = (roles: UserRole[] = []): boolean =>
  !(roles.length === 1 && roles.includes(UserRole.ReadOnly));
